var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-upload"},[_c('p',[_vm._v("ลากวางหรือคลิกเพื่ออัพโหลด")]),_c('input',{ref:"refInputUpload",attrs:{"type":"file","accept":"image/jpeg, image/png"},on:{"input":function($event){return _vm.onUpload($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }